import BackToTop from '@elem/compCommon/BackToTop';
import ShopifyCartIcon from '@elem/compCommon/ShopifyCartIcon';
import SideMenu, { SideMenuProps } from '@elem/compCommon/SideMenu';
import EcoDesignEventsBus from 'eco-design-micro/EcoDesignEventsBus';
import ShopifyShoppingCart from 'elem/compCommon/ShopifyShoppingCart';
import { ShopifyCartItemType } from 'elem/compCommon/ShopifyShoppingCart/const';
import { createPortal } from 'react-dom';
import { useGlobal } from '@/utils/useGlobal';
import B from './components/UsPage/B';
import C from './components/UsPage/C'
import D from './components/UsPage/D'
import E from './components/UsPage/E'
import F from './components/UsPage/F'
import G from './components/UsPage/G'
import TaxCredit from './components/TaxCredit';
import R from './components/UsPage/H';
import FooterTcA from './components/UsPage/FooterTcA';

export default function IndexDynamic() {
    const { useState, useRouter, useLang, useEffect } = useGlobal();
    const [shoppingCarts, setShoppingCarts] = useState([]);
    const [visible, setVisible] = useState(false);
    const [isClient, setIsClient] = useState(false);
    const [updateSolar, setUpdateSolar] = useState(null);
    const { locale } = useRouter();
    const { t } = useLang('costsaving-new');
    const isUs = ['us'].includes(locale);

    const obj: SideMenuProps = {
        items: [
            { text: t('secC_btn1'), link: '#cost-saving-C' },
            { text: t('secC_btn2'), link: '#cost-saving-E' },
            // { text: t('secC_btn3'), link: '#cost-saving-J' },
            // { text: t('secC_btn4'), link: '#cost-saving-L' },
        ],
    };

    const handleAddCart = (cards: ShopifyCartItemType[]) => {
        let result = JSON.parse(JSON.stringify(shoppingCarts));
        cards?.map((card: ShopifyCartItemType) => {
            const obj: ShopifyCartItemType = JSON.parse(JSON.stringify(card));
            if (card?.parentVariantId) {
                const target = result.find(
                    (item: ShopifyCartItemType) =>
                        item?.productId === card?.productId && item?.variantId === card?.variantId && item?.parentVariantId === card?.parentVariantId,
                );
                // 附属产品
                obj.quantity = Number(obj?.inventory) > 0 ? obj.quantity : 0;
                result = result.filter((item: ShopifyCartItemType) => !(item?.parentVariantId === card?.parentVariantId));
                if (target) {
                    result = [
                        obj,
                        ...result?.filter((item: any) => !(item?.variantId === target?.variantId && item?.parentVariantId === item?.parentVariantId)),
                    ];
                } else {
                    result = [obj, ...result];
                }
            } else {
                // 主产品
                const target = result.find((item: ShopifyCartItemType) => item?.productId === card?.productId && item?.variantId === card?.variantId);
                if (target) {
                    obj.quantity = target.quantity;
                    result = [
                        obj,
                        ...result?.filter((item: ShopifyCartItemType) => !(item?.productId === card?.productId && item?.variantId === card?.variantId)),
                    ];
                } else {
                    obj.quantity = Number(obj?.inventory) > 0 ? 1 : 0;
                    result = [obj, ...result];
                }
            }
        });
        //setShoppingCarts(result);
        EcoDesignEventsBus.emit('eco-cart-add', result);
        setVisible(true);
    };

    const handleCallback = (carts: ShopifyCartItemType[], isClose?: boolean, target?: string) => {
        //setShoppingCarts(carts);
        EcoDesignEventsBus.emit('eco-cart-add', carts);
        if (isClose) {
            setVisible(false);
        }
        if (target) {
            setUpdateSolar(target);
        }
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);

    return (
        <>

            <>
                <B />
                <C />
                <D />
                <E callBuy={handleAddCart} updateSolar={updateSolar} />
                <F />
                <G callBuy={handleAddCart} updateSolar={updateSolar} />
                <R />
                <FooterTcA />
            </>



            {visible && isClient && createPortal(<ShopifyShoppingCart callback={handleCallback} items={shoppingCarts} />, document.body)}
            {isClient &&
                createPortal(
                    <ShopifyCartIcon
                        quantity={shoppingCarts.reduce((prev: number, curItem: ShopifyCartItemType) => {
                            return prev + Number(curItem.quantity);
                        }, 0)}
                        callback={() => setVisible(true)}
                    />,
                    document.body,
                )}
            {isClient && createPortal(<BackToTop />, document.body)}
            {isClient && createPortal(<SideMenu items={obj.items} />, document.querySelector('#Widgets-box-in2-right-id') || document.body)}
        </>
    );
}
